<template>
  <div class="app-container">
    <el-card>
      <div class="searchTitle">数据筛选</div>
      <el-form :inline="true" :model="params">
        <el-form-item label="商品ID：">
          <el-input
            v-model="params.id"
            class="input-width"
            placeholder="请输入商品ID"
          />
        </el-form-item>

        <el-form-item label="商品名称：">
          <el-input
            v-model="params.name"
            class="input-width"
            placeholder="请输入商品名称"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="Search" @click="queryTableList()"
            >查询</el-button
          >
          <el-button icon="Refresh" @click="resetParams()">重置</el-button>
        </el-form-item>
      </el-form>
      
      <div class="searchTitle">视频生成队列：{{ waitNum }}<el-button type="success"    @click="
                  () => {
                    $router.push({
                      path: 'generateProductVideo',
                      query: {
                        type: 1,
                      },
                    });
                  }
                ">新增智能视频（商品类）</el-button><el-button type="warning" @click="goQueue">查看视频生成队列</el-button></div>
      

      <div class="table-container">
        <el-table
          v-loading="listLoading"
          :data="tableList"
          border
          style="width: 100%"
          height="68vh"
          :header-cell-style="{
            background: '#f0f0f0',
            color: '#000',
          }"
        >
          <el-table-column
            align="center"
            label="商品ID"
            prop="id"
            width="120"
          />

          <el-table-column align="center" label="商品名称" prop="name" />
          <!-- <el-table-column align="center" label="视频时长" prop="contactName" /> -->
          <el-table-column align="center" label="智慧AI视频" prop="contactName">
            <template #default="scope">
              <video
                v-if="scope.row.aiVideoUrl"
                class="videoCover"
                :src="scope.row.aiVideoUrl"
                :controls="false"
                @click="() => $refs.showVideoRef?.open(scope.row.aiVideoUrl)"
              ></video>
              <div v-else class="emptyText">暂无</div>
            </template>
          </el-table-column>
            <el-table-column align="center" label="播放顺序" width="120">
            <template slot-scope="scope">
               <el-input
                v-model="scope.row.videoSort"
                suffix-icon="el-icon-edit el-input__icon"
                type="number"
                @change="sortLocalChange(scope.row)"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="更多操作" prop="action">
            <template #default="scope">
              <el-button
                type="primary"
                v-if="scope.row.processStepStatus == 1"
                @click="
                  () => {
                    $router.push({
                      path: 'generateProductVideo',
                      query: {
                        id: scope.row.id,
                        name: scope.row.name,
                        imageUrl: scope.row.imageUrl,
                        type: 2,
                      },
                    });
                  }
                "
                >生成智能视频</el-button
              >
              <el-button
                v-if="scope.row.processStepStatus == 2||scope.row.processStepStatus == 0"
                type="primary"
                plain
                @click="
                  () => {
                    $router.push({
                      path: 'generateProductVideo',
                      query: {
                        id: scope.row.id,
                        name: scope.row.name,
                        imageUrl: scope.row.imageUrl,
                        type: 3,
                      },
                    });
                  }
                "
                >修改视频</el-button
              >
               <el-button type="text" style="color:#f56c6c" @click="deleteAct(scope.row)"
                >删除视频</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-container" style="margin-top: 20px">
        <el-pagination
          :current-page="params.pageNo"
          :page-size="params.pageSize"
          :page-sizes="[10, 20, 30]"
          :total="total"
          background
          layout="total, sizes,prev, pager, next,jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-card>
    <ShowVideo ref="showVideoRef" />
  </div>
</template>
<script>
import { aiProductPage, queryVideoWaitNum,updateAiVideo,deleteAiVideo } from "@/assets/api/aiProduct";
import ShowVideo from "./product/components/showVideo";
export default {
  components: {
    ShowVideo,
  },
  data() {
    return {
      params: {
        pageNo: 1,
        pageSize: 10,
        id: "",
        name: "",
      },
      listLoading: false,
      tableList: [],
      total: 0,
      waitNum: 0,
    };
  },
  mounted() {
    this.queryTableList();
    this.queryNum();
  },
  methods: {
     goQueue (){
  this.$router.push({path:'productqueue'})
},
        // 删除
   deleteAct(row) {
     this.$confirm('是否确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          const res = await deleteAiVideo({id:row.id})
         if(res.code==200){
         this.$message.success(res.message)
         this.queryTableList()
         } else {
          this.$message.error(res.message);
        }
        })
   
    },
         // 更改排序规则
    async sortLocalChange(row) {
        const res = await updateAiVideo({
          productId:row.id,
          videoSort:row.videoSort
        });
        if (res.code == 200) {
          this.$message.success(res.message);
          this.queryTableList();
        }else{
        this.$message.error(res.message);
        }
     
    },
    /** 查询排队数量 */
    queryNum() {
      queryVideoWaitNum().then((res) => {
        if (res.code === "200") {
          this.waitNum = res.data.waitNum;
        }
      });
    },
    /**
     * 查询表格数据
     */
    queryTableList() {
      this.listLoading = true;
      aiProductPage(this.params).then((res) => {
        this.listLoading = false;
        const { list } = res.data || {};
        this.tableList = list || [];
        this.total = Number(res.data.total) || 0;
      });
    },
    //重置参数
    resetParams() {
      this.params.pageNo = 1;
      this.params.pageSize = 10;
      this.params.id = "";
      this.params.name = "";
      this.queryTableList();
    },
    handleSizeChange(val) {
      this.params.pageNo = 1;
      this.params.pageSize = val;
      this.queryTableList();
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.queryTableList();
    },
  },
};
</script>

<style scoped>
.searchTitle {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  width: 500px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.videoCover {
  width: 200px;
  height: 200px;
}

.emptyText {
  color: #acb2c3;
  font-size: 14px;
}
</style>
